'use strict';

var React = require('react');
var compose = require('../hoc/compose');
var template = require('./radioButton.rt');
var displayNames = require('./displayNames');

var RadioButton = template;

RadioButton.displayName = displayNames.RADIO_BUTTON;
RadioButton.propTypes = {
    value: React.PropTypes.string.isRequired,
    name: React.PropTypes.string.isRequired,
    onChange: React.PropTypes.func.isRequired,
    selected: React.PropTypes.bool,
    disabled: React.PropTypes.bool,
    showRadioSymbol: React.PropTypes.bool
};
RadioButton.defaultProps = {
    selected: false,
    disabled: false,
    showRadioSymbol: true
};

module.exports = compose(RadioButton);


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/radioButton.js